import React from 'react';
import PropTypes from 'prop-types';
import anime from 'animejs';
import { RED, GREY } from './Colors.js';

export default class Triangle extends React.Component {
  componentDidMount() {
    if (!this.props.animeProps) { return; }
    anime({
      targets: this.refs.triangle,
      ...this.props.animeProps,
      loop: true
    });
  }

  render() {
    return (
      <svg
        className={`triangle shape ${this.props.className}`}
        viewBox="0 0 96 96"
        ref="triangle"
        style={{transform: this.props.initialTransform, transformOrigin: 'center'}}
      >
        <defs>
          <radialGradient id="triangleGradient" cx="40%" cy="-10%" fy="0%" r="90%">
            <stop stopColor={RED} stopOpacity="1" offset="0%"/>
            <stop stopColor={RED} stopOpacity="1" offset="30%"/>
            <stop stopColor={GREY} stopOpacity="0" offset="100%"/>
          </radialGradient>
        </defs>
        <polygon fillRule="evenodd" points="48 17.28 86.4 80.11584 9.6 80.11584" strokeLinecap="square" fill="url(#triangleGradient)"/>
      </svg>
    );
  }
}

Triangle.propTypes = {
  className: PropTypes.string,
  animeProps: PropTypes.object,
  initialTransform: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/Components/Animation/Shapes/Triangle.js